module.exports = __webpack_public_path__ + "static/media/workingmemory-words-intro.c1200f49.mp3";